// external imports
import React from 'react'
import { Text } from 'quark-web'
import { larkYellow, darkGrey, primaryColor } from '~/colors'

export default ({ style, ...unused }) => (
    <Text
        {...unused}
        style={{
            fontFamily: 'Lato, Arial, Helvetica, sans-serif',
            color: darkGrey,
            ...style
        }}
    />
)



// WEBPACK FOOTER //
// ./src/components/Text.js